import {
  Box,
  Grid,
  Link,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDateTextInput from "../../unit/CustomDateTextInput";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import CustomTable from "../../unit/CustomTable";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import CustomIntNumberTextField from "../../unit/forms/CustomIntNumberTextField";
import CustomNumberTextField from "../../unit/forms/CustomNumberTextField";
import CustomSelect from "../../unit/forms/CustomSelect";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import PaperComponent from "../../unit/PaperComponent";
import useNotify from "../../unit/useNotify";
import { set } from "lodash";
import NoResults from "../../unit/NoResults";
import CustomPaper from "../../unit/CustomPaper";

const CustomPreviewData = ({ ...props }) => {
  const dataArray = props.data;
  let prev: null = null;
  const getActualInterestAmountPaid = (item: any, prev: any) => {
    let dActualAmountPaid = parseFloat(item.dActualAmountPaid);
    let interestAmount_total = 0;
    let latefee_total = 0;
    if (prev && prev.dInterestPastDueSum) {
      interestAmount_total =
        parseFloat(item.interestAmount) + parseFloat(prev.dInterestPastDueSum);
    } else {
      interestAmount_total = parseFloat(item.interestAmount);
    }
    if (prev && prev.dLateFeePastDueSum) {
      latefee_total =
        parseFloat(item.dLateFees) + parseFloat(prev.dLateFeePastDueSum);
    } else {
      latefee_total = parseFloat(item.dLateFees);
    }
    if (interestAmount_total > 0) {
      if (dActualAmountPaid >= interestAmount_total) {
        return dActualAmountPaid > 0
          ? formatCurrency(interestAmount_total)
          : "";
      } else {
        return dActualAmountPaid > 0 ? formatCurrency(dActualAmountPaid) : "";
      }
    } else {
      return dActualAmountPaid > 0 ? formatCurrency(dActualAmountPaid) : "";
    }
  };

  let show_invoice_edit = false;
  let latefeeSum = 0;
  let eq_cal = 0;

  return (
    <TableContainer
      component={CustomPaper}
      sx={{
        mt: 2,
        width: `calc(100%)`,
        height: `280px`,
        overflow: "auto",
      }}
    >
      <CustomTable
        stickyHeader
        sx={{
          "& .MuiTableRow-head": {
            border: "1px solid #d5d5d5",
            backgroundColor: "#edf4fb",
            height: "50px",
            maxHeight: "50px",
            color: "red",
          },

          "& .MuiTableCell-head": {
            backgroundColor: "#edf4fb",
            height: "50px",
            maxHeight: "50px",
          },
        }}
      >
        <TableHead>
          <TableRow>
            {/* <TableCell>Payment Number</TableCell> */}
            <TableCell>Payment Due Date</TableCell>
            <TableCell align="right">Expected Payment Amount</TableCell>
            {/* <TableCell>Invoice Amount</TableCell>
          <TableCell>Actual Payment Date</TableCell>
          <TableCell>Actual Payment Amount</TableCell>
          <TableCell>Interest Paid</TableCell>
          <TableCell>Principal Paid</TableCell>
          <TableCell>Cumulative Principal Balance</TableCell>
          <TableCell>Remaining Principal Balance</TableCell>
          <TableCell>Days Past Due</TableCell>
          <TableCell>Amount Past Due</TableCell>
          <TableCell>Late Fees</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {dataArray == undefined ||
          dataArray.length == 0 ||
          dataArray == null ? (
            <TableRow>
              <TableCell colSpan={13} className="no-results">
                <NoResults />
              </TableCell>
            </TableRow>
          ) : (
            <>
              {dataArray.map((item: any, index: any) => {
                if (item.dActualAmountPaid > 0 && item.principalReduction > 0) {
                  eq_cal += item.principalReduction;
                }
                if (index > 0) {
                  prev = dataArray[index - 1];
                }
                if (item.sStatus != "pending") {
                  // continue;
                  return null;
                }

                return (
                  <TableRow key={index}>
                    {/* <TableCell>{index + 1}</TableCell> */}
                    <TableCell>{formatDate(item.dPaymentDate)}</TableCell>
                    <TableCell className="amountText" align="right">
                      {formatCurrency(item.paymentAmount)}
                    </TableCell>
                    {/* <TableCell>
                    {item.dPaymentDate < new Date()
                      ? formatCurrency(item.dOriginalInvoiceAmount)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dLastActualPaidDate != "" &&
                    item.dLastActualPaidDate != "0000-00-00 00:00:00"
                      ? formatDate(item.dLastActualPaidDate)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0
                      ? formatCurrency(item.dActualAmountPaid)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {getActualInterestAmountPaid(item, prev)}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0 && item.principalReduction > 0
                      ? formatCurrency(item.principalReduction)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0 ||
                    item.sStatus == "expired" ||
                    item.sStatus == "failed"
                      ? formatCurrency(eq_cal)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0 && item.dActualLoanBalance > 0
                      ? formatCurrency(item.dActualLoanBalance)
                      : ""}
                  </TableCell>
                  <TableCell>{item.iDaysPastDue}</TableCell>
                  <TableCell>
                    {" "}
                    {item.dActualAmountPaid > 0 ||
                    item.sStatus == "expired" ||
                    item.sStatus == "failed"
                      ? formatCurrency(item.dAmountPastDue)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0 ||
                    item.sStatus == "expired" ||
                    item.sStatus == "failed"
                      ? formatCurrency(item.dLateFees)
                      : ""}
                  </TableCell> */}
                  </TableRow>
                );
              })}
            </>
          )}
        </TableBody>
      </CustomTable>
    </TableContainer>
  );
};
export default function CustomLoanReduceDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const showSkipExtend = record?.showSkipExtend ? true : false;
  const [previewData, setPreviewData] = React.useState<any[]>([]);
  const [revisedData, setRevisedData] = React.useState<any[]>([]);
  const [submitTitle, setSubmitTitle] = React.useState("Confirm");
  const [previewTitle, setPreviewTitle] = React.useState("Preview");
  const lastDate = record?.lastDate;
  const [remainingPayments, setRemainingPayments] = React.useState(
    record?.loan?.remainingPayments
  );
  const [minFixedAmount, setMinFixedAmount] = React.useState(0);
  const accruedInterestAmount = record?.accruedInterestAmount?.toString();
  const oldAmount = record?.unpaid_principal?.toString();
  const [balance, setBalance] = React.useState(oldAmount);
  const [amountEditabled, setAmountEditabled] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [isSubmit, setIsSubmit] = React.useState(false);
  const [isPreview, setIsPreview] = React.useState(false);
  const [showFixedPaymentAmount, setShowFixedPaymentAmount] =
    React.useState(false);
  const [submitFormData, setSubmitFormData] = React.useState({
    type: "reducePayment",
    userset: "yes",
    applicationId: appId,
    remaining_payment_terms: remainingPayments,
    remaining_payment_amount: record?.loan?.nextPaymentAmount,
    reduced_payment_amount: "",
    number_payment_periods: "",
    first_payment_date: record?.loan?.nextPaymentDate,
    iPaymentRoundUp: "",
    notes: "",
  });
  const refresh = useRefresh();
  React.useEffect(() => {
    //check submitFormData data, if ok, show preview button
    if (
      submitFormData.remaining_payment_terms &&
      submitFormData.remaining_payment_amount &&
      submitFormData.reduced_payment_amount &&
      submitFormData.number_payment_periods &&
      submitFormData.first_payment_date
    ) {
      setIsPreview(true);
    } else {
      setIsPreview(false);
    }
  }, [submitFormData]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPreviewData([]);
    setRevisedData([]);
    setIsPreview(false);
    setSubmitTitle("Confirm");
    setPreviewTitle("Preview");
  };
  const handleCloseWhenPreview = () => {
    setOpen(false);
    setIsSubmit(false);
    setPreviewData([]);
    setRevisedData([]);
    setIsPreview(false);
    setSubmitTitle("Confirm");
    setPreviewTitle("Preview");
  };
  const handleRefreshFun = () => {
    refresh();
  };
  const handleSubmitModify = async () => {
    const formJson = {
      type: "reducePayment",
      userset: "yes",
      applicationId: appId,
      remaining_payment_terms: remainingPayments,
      remaining_payment_amount: submitFormData.remaining_payment_amount,
      reduced_payment_amount: submitFormData.reduced_payment_amount,
      number_payment_periods: submitFormData.number_payment_periods,
      first_payment_date: submitFormData.first_payment_date,
      org_payment_date: record?.curPV?.dPaymentDate,
      org_maturity_date: record?.loan?.maturityDate,
      iPaymentRoundUp: submitFormData.iPaymentRoundUp,
      //"onlyGetPaymentTerms":'yes',
      notes: submitFormData.notes,
    };

    setSubmitTitle("loading");
    const reqUrl = `create/payment/schedule`;
    const responseBack = await sendRequest(reqUrl, {
      id: appId,
      data: formJson,
    });
    if (responseBack && responseBack.code == "200") {
      let previewData = responseBack.data;
      setPreviewData([]);
      setRevisedData([]);
      successNotify("Data saved successfully");
      handleRefreshFun();
      handleClose();
      // refresh();
    } else {
      errorNotify(responseBack?.message || "Data not saved!");
    }

    setIsSubmit(false);
    setSubmitTitle("Confirm");
    setPreviewData([]);
    setRevisedData([]);
  };
  if (showSkipExtend == false) {
    return (
      <Link
        id="link-loan-reduce-payment"
        sx={{
          marginLeft: "10px",
          "&": { textDecoration: "none" },
          "&:hover": {
            background: "none",
          },
          color: "grey",
        }}
      >
        Reduce Select Payments
      </Link>
    );
  }

  const RevisedTable = ({ ...props }) => {
    const revisedData = props.revisedData;
    const curPV = props?.curPV;
    // console.log("revisedData in RevisedTable===>", revisedData);
    // console.log("curPV in RevisedTable===>", curPV);
    return (
      <>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Remaining Principal:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {formatCurrency(record?.unpaid_principal)}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Remaining Principal:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {formatCurrency(revisedData.amount)}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Interest Rate:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.interestRate}%
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Interest Rate:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData?.rate}%
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Payment Frequency:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.paymentFrequency}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Payment Frequency:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData?.paymentfrequency}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Maturity Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.maturityDate
              ? formatDate(record.loan.maturityDate)
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Maturity Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.maturitydate
              ? formatDate(revisedData.maturitydate)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Next Payment Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.nextPaymentDate
              ? formatDate(record.loan.nextPaymentDate)
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Next Payment Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.nextpaymentdate
              ? formatDate(revisedData.nextpaymentdate)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Next Payment Due:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.nextPaymentAmount
              ? formatCurrency(record.loan.nextPaymentAmount)
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Next Payment Due:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.nextpaymentamount
              ? formatCurrency(revisedData.nextpaymentamount)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Term Starting Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {curPV?.dModifyNoteDate &&
            curPV?.dModifyNoteDate != "0000-00-00" &&
            curPV?.dModifyNoteDate != "0000-00-00 00:00:00"
              ? `${formatDate(curPV?.dModifyNoteDate)}`
              : curPV?.dNoteDate &&
                curPV?.dNoteDate != "0000-00-00 00:00:00" &&
                curPV?.dNoteDate != "0000-00-00"
              ? `${formatDate(curPV?.dNoteDate)}`
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Term Starting Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.startdate ? formatDate(revisedData.startdate) : ""}
          </Grid>
        </Grid>
      </>
    );
  };

  return (
    <React.Fragment>
      <Link
        sx={{
          marginLeft: "10px",
          "&": { textDecoration: "none" },
          "&:hover": {
            background: "none",
          },
        }}
        onClick={handleClickOpen}
      >
        Reduce Select Payments
      </Link>
      <Dialog
        id="dialog-loan-reduce-payment"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();

            const formJson = {
              type: "reducePayment",
              userset: "yes",
              applicationId: appId,
              remaining_payment_terms: submitFormData.remaining_payment_terms,
              remaining_payment_amount: submitFormData.remaining_payment_amount,
              reduced_payment_amount: submitFormData.reduced_payment_amount,
              number_payment_periods: submitFormData.number_payment_periods,
              first_payment_date: submitFormData.first_payment_date,
              org_payment_date: record?.curPV?.dPaymentDate,
              org_maturity_date: record?.loan?.maturityDate,
              iPaymentRoundUp: submitFormData.iPaymentRoundUp,
              //"onlyGetPaymentTerms":'yes',
              notes: submitFormData.notes,
            };

            console.log("reduce dialog formJson ====>", formJson);

            if (
              formJson.remaining_payment_terms == 0 ||
              formJson.remaining_payment_terms == "0" ||
              formJson.remaining_payment_amount == 0 ||
              formJson.remaining_payment_amount == "0" ||
              formJson.reduced_payment_amount == 0 ||
              formJson.reduced_payment_amount == "0" ||
              formJson.number_payment_periods == 0 ||
              formJson.number_payment_periods == "0" ||
              formJson.first_payment_date == "" ||
              formJson.first_payment_date == "0" ||
              formJson.iPaymentRoundUp == "" ||
              formJson.iPaymentRoundUp == "0"
            ) {
              errorNotify("Please fill all the fields");
              return false;
            }
            //number_payment_periods 1-12
            if (
              formJson.number_payment_periods < 1 ||
              formJson.number_payment_periods > 12
            ) {
              errorNotify(
                "Number of reduced payments must be between 1 and 12"
              );
              return false;
            }

            setPreviewTitle("loading");
            const reqUrl = `create/payment/schedule/preview`;

            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            setIsPreview(true);

            if (responseBack && responseBack.code == "200") {
              let previewData = responseBack.data;
              let revisedData = responseBack?.revisedData;
              setRevisedData(revisedData);
              let previewDataArray = [];
              for (let key in previewData) {
                previewDataArray.push(previewData[key]);
              }
              setPreviewData(previewDataArray);
              successNotify("Data saved successfully");
              setIsPreview(false);
              setPreviewTitle("Preview");
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
              setIsPreview(false);
              setPreviewTitle("Preview");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomDialogTitle
            title={`${record?.loan?.loanStatus} Loan`}
            subTitle="Reduce Select Payments"
          />
        </DialogTitle>
        <DialogContent>
          <Box>
            <DialogContentText>
              This function reduces (or increases) the installment payment
              amount for a limited period (up to 12 months) before resuming the
              payments at the contractual amount. The reduced payment amount
              must be higher than the accrued interest.
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ my: 2, color: "red" }}
              >
                Resetting payment schedule of any kind is limited to only once
                per day. This change is irreversible. Please check all the
                inputs and carefully preview the results before clicking
                “Confirm” to commit the changes.
              </Typography>
            </DialogContentText>
            {previewData.length ? (
              <>
                <RevisedTable revisedData={revisedData} curPV={record?.curPV} />
                <CustomPreviewData data={previewData} />
              </>
            ) : (
              <Box id="reduce-loan-schedule-form" sx={{ mt: 2 }}>
                {/* Reduced Payment Amount: */}
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle
                      title="Reduced Payment Amount"
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <CustomNumberTextField
                      id="reduced_payment_amount"
                      name="reduced_payment_amount"
                      value={submitFormData.reduced_payment_amount}
                      onChange={(e) => {
                        setSubmitFormData({
                          ...submitFormData,
                          reduced_payment_amount: e.target.value,
                        });
                      }}
                      placeholder="Reduced Payment Amount"
                      fullWidth
                      variant="outlined"
                      required
                      className="amoutText"
                    />
                  </Grid>
                  <Grid item xs={2} sx={{ pt: 1 }}></Grid>
                </Grid>
                {/* Number Of Reduced Payments: */}
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle
                      title="Number Of Reduced Payments"
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <CustomIntNumberTextField
                      id="number_payment_periods"
                      name="number_payment_periods"
                      value={submitFormData.number_payment_periods}
                      maxNum={12}
                      minNum={1}
                      onChange={(e) => {
                        setSubmitFormData({
                          ...submitFormData,
                          number_payment_periods: e.target.value,
                          remaining_payment_terms:
                            remainingPayments - e.target.value,
                        });
                      }}
                      placeholder="Number Of Reduced Payments"
                      fullWidth
                      variant="outlined"
                      required
                      className="numericText"
                    />
                  </Grid>
                  <Grid item xs={2} sx={{ pt: 1 }}></Grid>
                </Grid>
                {/* First Reduced Payment Date: */}
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle
                      title="First Reduced Payment Date"
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <CustomDateTextInput
                      id="first_payment_date"
                      name="first_payment_date"
                      value={submitFormData.first_payment_date}
                      onChange={(value: any) => {
                        setSubmitFormData({
                          ...submitFormData,
                          first_payment_date: value,
                        });

                        console.log("first_payment_date===>", submitFormData);
                      }}
                      placeholder="First Reduced Payment Date"
                      fullWidth
                      variant="outlined"
                      required
                      className="dateText"
                    />
                  </Grid>
                  <Grid item xs={2} sx={{ pt: 1 }}></Grid>
                </Grid>
                {/* iPaymentRoundUp */}
                <Grid sx={{ mb: 2 }} container>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <HeaderLabelTitle
                      title="Round Up Payment"
                      required={true}
                    />
                  </Grid>
                  <Grid item xs={5} sx={{ pt: 1 }}>
                    <CustomSelect
                      fullWidth={true}
                      id="iPaymentRoundUp"
                      name="iPaymentRoundUp"
                      optionlist={[
                        { label: "Yes", value: "YES" },
                        { label: "No", value: "NO" },
                      ]}
                      value={submitFormData.iPaymentRoundUp}
                      required={true}
                      variant="outlined"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setSubmitFormData({
                          ...submitFormData,
                          iPaymentRoundUp: e.target.value.toString(),
                        });
                      }}
                    />
                  </Grid>
                  <Grid item xs={2} sx={{ pt: 1 }}></Grid>
                </Grid>
                <Grid container sx={{ mb: 2, pb: 2 }}>
                  <Grid sx={{ mb: 2 }} container>
                    <HeaderLabelTitle
                      title="Add Note (Max 150 Characters)"
                      suffix=""
                    />
                  </Grid>
                  <Grid sx={{ mb: 2 }} container>
                    <TextField
                      id="notes"
                      name="notes"
                      placeholder="Notes"
                      onKeyDown={(event) => {
                        event.stopPropagation();
                      }}
                      multiline={true}
                      minRows={2}
                      fullWidth
                      variant="outlined"
                      onChange={(e) => {
                        setSubmitFormData({
                          ...submitFormData,
                          notes: e.target.value,
                        });
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel
            onClick={isSubmit ? handleCloseWhenPreview : handleClose}
          />
          {!previewData.length && (
            <CustomButtonSubmit
              label={previewTitle}
              disabled={previewTitle == "loading" ? true : false}
            />
          )}
          {previewData.length > 0 && (
            <CustomButtonSave
              color="primary"
              onClick={handleSubmitModify}
              label={submitTitle}
              variant="contained"
              disabled={submitTitle == "loading" ? true : false}
            />
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
